import Http from './../http';

const prefix = '/automatic-emails';

export const getAll = (encryptedID, typeTool = false) => Http.authApi().get(`${prefix}/all/${encryptedID}` + (typeTool ? `/${typeTool}` : ''));

export const edit = (emailTheme, typeTool = false) => {
  return Http.authApi().put(`${prefix}/${emailTheme.website.encrypted_id}` + (typeTool ? `/${typeTool}` : ''), emailTheme);
};



// WEBPACK FOOTER //
// ./src/js/services/restrictArea/automaticEmails.js